import React from "react"

// The divider was a fixed 124px SVG in a hardcoded light grey, so it stopped
// short of both edges and stayed light in dark mode. A full-width token border on
// every item but the first gives even separators that adapt to the theme.
const PopoverItem = ({ onClick, title = '', withBreakLine = true }) => {
  return (
    <div
      className={`w-full cursor-pointer text-text-primary text-sm leading-[150%] hover:bg-surface px-3.5 py-2 ${
        withBreakLine ? 'border-t border-divider' : ''
      }`}
      onClick={onClick}
    >
      {title}
    </div>
  )
}

export default PopoverItem
